import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'pigmentos-cookie-consent';

// Estado de consentimento partilhado (localStorage + evento para os componentes reagirem).
export const getCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setCookieConsent = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* localStorage indisponível — segue sem persistir */
  }
  window.dispatchEvent(new CustomEvent('cookie-consent-change', { detail: value }));
};

const COPY = {
  pt: {
    text: 'Utilizamos cookies essenciais ao funcionamento do site e, com o seu consentimento, cookies de análise e marketing (Meta/Facebook e Google) e do mapa Google Maps, para medir e melhorar os nossos anúncios. Pode aceitar ou recusar.',
    accept: 'Aceitar',
    reject: 'Recusar',
    policy: 'Política de Cookies',
  },
  en: {
    text: 'We use cookies essential to the site and, with your consent, analytics and marketing cookies (Meta/Facebook and Google) and the Google Maps embed, to measure and improve our ads. You can accept or decline.',
    accept: 'Accept',
    reject: 'Decline',
    policy: 'Cookie Policy',
  },
};

const CookieConsent = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    setCookieConsent(value);
    setVisible(false);
  };

  if (!visible) return null;
  const c = COPY[language] || COPY.pt;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-4 sm:p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-orange-600" />
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            {c.text}{' '}
            <a
              href="/privacidade#cookies"
              className="text-orange-600 hover:text-orange-700 underline underline-offset-2"
            >
              {c.policy}
            </a>
          </p>
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto flex-shrink-0">
          <button
            onClick={() => choose('rejected')}
            className="flex-1 sm:flex-none px-5 py-2.5 rounded-lg text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            {c.reject}
          </button>
          <button
            onClick={() => choose('accepted')}
            className="flex-1 sm:flex-none px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 transition-colors"
          >
            {c.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
